import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { isArray } from 'lodash';
import qs from 'qs';
import { api } from '.';
import { PROVIDER_SOURCE_LIST, QUOTE_PURCHASE_PROBABILITY_MAP, getQuoteInsuranceTypeCovertToLocalTypeMap } from '../constants/quote';
import { getBusinessInsuranceTypes } from '../localeConstants';
import { handleRequestError } from '../utils/request';
import { formatCommonDateStr, formatCommonDateStrKeepDatePart } from '../utils/time';
export var apiApprovalQuoteReferral = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.post("/admin/quotes/".concat(payload.quoteId, "/universal/approval-referral"), payload);

          case 3:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function apiApprovalQuoteReferral(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiQueryQuoteList = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload, config) {
    var _res$data, res;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.get("/quotes?".concat(qs.stringify(payload, {
              arrayFormat: 'repeat'
            })), config);

          case 3:
            res = _context2.sent;

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data)) {
              res.data.data = res.data.data.map(function (item) {
                var _getBusinessInsurance, _PROVIDER_SOURCE_LIST, _QUOTE_PURCHASE_PROBA;

                if (!item.payload) {
                  item.payload = {};
                }

                var _item$payload = item.payload,
                    firstName = _item$payload.firstName,
                    lastName = _item$payload.lastName,
                    insuranceType = _item$payload.insuranceType,
                    providerCode = _item$payload.providerCode,
                    purchaseProbability = _item$payload.purchaseProbability;
                item.createdAtText = formatCommonDateStr(item.createdAt);
                item.updatedAtText = formatCommonDateStrKeepDatePart(item.updatedAt);
                item.payload.fullName = "".concat(firstName, " ").concat(lastName);
                item.payload.insuranceTypeText = (_getBusinessInsurance = getBusinessInsuranceTypes().find(function (aItem) {
                  return aItem.value === getQuoteInsuranceTypeCovertToLocalTypeMap()[insuranceType];
                })) === null || _getBusinessInsurance === void 0 ? void 0 : _getBusinessInsurance.label;
                item.payload.insurerText = (_PROVIDER_SOURCE_LIST = PROVIDER_SOURCE_LIST().find(function (aItem) {
                  return aItem.value === providerCode;
                })) === null || _PROVIDER_SOURCE_LIST === void 0 ? void 0 : _PROVIDER_SOURCE_LIST.label;
                item.payload.purchaseProbabilityText = ((_QUOTE_PURCHASE_PROBA = QUOTE_PURCHASE_PROBABILITY_MAP()[purchaseProbability]) === null || _QUOTE_PURCHASE_PROBA === void 0 ? void 0 : _QUOTE_PURCHASE_PROBA.label) || '-';
                item.purchasedAtText = formatCommonDateStr(item.purchasedAt);
                return item;
              });
            }

            return _context2.abrupt("return", [res.data]);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0, payload));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function apiQueryQuoteList(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiDeclineQuoteReferral = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.post("/admin/quotes/".concat(payload.quoteId, "/universal/decline"));

          case 3:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data]);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0, payload));

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function apiDeclineQuoteReferral(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiSendQuoteReferralEmails = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.post("/admin/quotes/".concat(payload.quoteId, "/universal/send_referral_email"));

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data]);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0, payload));

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function apiSendQuoteReferralEmails(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiQueryPolicyPreviewPrice = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.patch("/policies/".concat(payload.policyId, "/draft-price"), payload);

          case 3:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data]);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0, payload));

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));

  return function apiQueryPolicyPreviewPrice(_x6) {
    return _ref5.apply(this, arguments);
  };
}();